import { call, put } from "redux-saga/effects";
import { default as api } from "../../../util/api";
import { SPECIAL_ORDER_QUEUE_URL } from "../../../util/constants/api.constants";
import {
  fetchSpecialOrdersSuccess,
  fetchSpecialOrdersFail,
  fetchVendorReceiptSuccess,
  fetchVendorReceiptFail,
} from "./actions";
import { toQueryParam } from "../../../util/utils";

export function* fetchSpecialOrders({ payload }: any): Generator {
  try {
    const response: any = yield call(api.post, SPECIAL_ORDER_QUEUE_URL.REQUEST_SPECIAL_ORDER, payload);
    yield put(fetchSpecialOrdersSuccess(response));
  } catch (e: any) {
    yield put(fetchSpecialOrdersFail({ message: e.message }));
  }
}

export function* fetchVendorReceipt({ payload }: any): Generator {
  try {
    const response: any = yield call(api.post, SPECIAL_ORDER_QUEUE_URL.VENDOR_RECEIPT, payload);
    yield put(fetchVendorReceiptSuccess(response));
  } catch (e: any) {
    yield put(fetchVendorReceiptFail({ message: e.message }));
  }
}